module.exports = __webpack_public_path__ + "img/dashboard-create.65bd634d.png";